export const SUBMIT_BBV_REPORT_SUCCESS = "SUBMIT_BBV_REPORT_SUCCESS";
export const BBV_REPORT_SUCCESSOR_TASKS_LOAD_SUCCESS = "BBV_REPORT_SUCCESSOR_TASKS_LOAD_SUCCESS";
